import type {
  FailureReason,
  MessageType,
} from "../../../services/client/types.gen";

export const MESSAGE_TYPE_LABELS: Record<MessageType, string> = {
  MEASUREMENT: "Measurement",
  TRANSACTION: "Transaction",
  TRANSACTION_EVENT: "Transaction",
  TRANSACTION_EVENT_DROPPED: "Transaction",
  UNKNOWN: "Unknown",
};

export const FAILURE_REASON_LABELS: Record<FailureReason, string> = {
  VALIDATION_ERROR: "Invalid message",
  PARSE_NON_VALIDATION_ERROR: "Could not be parsed",
  DATABASE_ERROR: "Could not be stored",
  UNKNOWN_ERROR: "Unknown error",
  EVENT_LOG_CAPPED: "Too many Transaction events",
};

export const FAILURE_REASON_COLORS: Record<FailureReason, string> = {
  VALIDATION_ERROR: "orange",
  PARSE_NON_VALIDATION_ERROR: "volcano",
  DATABASE_ERROR: "red",
  UNKNOWN_ERROR: "red",
  EVENT_LOG_CAPPED: "gold",
};
